module.exports = __webpack_public_path__ + "./images/5ef8344129de2cfd5abff66e8187e868.jpg";